// App Registration pour l'add-in Outlook (meme tenant)
// App Registration principale (ajouter http://localhost:4000 comme SPA redirect URI)
export const CLIENT_ID = "2dc4c2c5-a16d-44b2-ae44-75217e8a8c74";
export const TENANT_ID = "47e7dca7-e0c1-4f14-b7b4-f3dc93e5c0ea";
// VPS API
export const VPS_API_URL = "https://avhrh.avh.asso.fr";
export const API_SCOPE = "api://2dc4c2c5-a16d-44b2-ae44-75217e8a8c74/user_impersonation";
export const msalConfig = {
    auth: {
        clientId: CLIENT_ID,
        authority: `https://login.microsoftonline.com/${TENANT_ID}`,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage",
    },
};
export const graphScopes = [
    "User.Read",
    "User.Read.All",
    "Sites.ReadWrite.All",
    "Mail.Send",
];
// Scopes pour le token VPS API (backend valide avec audience = App ID URI)
export const apiScopes = [API_SCOPE];
